import React from 'react';

const NotFound404 = () => (
  <>
    <h1>404: Page Not Found</h1>
    <h2>Navigate back to About to provide more help to kids!</h2>
  </>
);

export default NotFound404;